"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetExtendedContactDetailsAllOfStatisticsClicked {
    static getAttributeTypeMap() {
        return GetExtendedContactDetailsAllOfStatisticsClicked.attributeTypeMap;
    }
}
GetExtendedContactDetailsAllOfStatisticsClicked.discriminator = undefined;
GetExtendedContactDetailsAllOfStatisticsClicked.attributeTypeMap = [
    {
        "name": "campaignId",
        "baseName": "campaignId",
        "type": "number"
    },
    {
        "name": "links",
        "baseName": "links",
        "type": "Array<GetExtendedContactDetailsAllOfStatisticsLinks>"
    }
];
exports.GetExtendedContactDetailsAllOfStatisticsClicked = GetExtendedContactDetailsAllOfStatisticsClicked;
//# sourceMappingURL=getExtendedContactDetailsAllOfStatisticsClicked.js.map